import { ClassProvider, InjectionToken } from '@angular/core';
import type { Environment } from '../../../../../environments/environment.type';
import { SpeechToTextAzureApiKeyService } from './azure/speech-to-text-azure-api-key.service';
import { SpeechToTextAzureService } from './azure/speech-to-text-azure.service';
import { SpeechToTextApiKeyServiceInterface, SpeechToTextServiceInterface } from './prompt-input-speech-to-text.interfaces';

export const Tokens = {
  SpeechToTextService: new InjectionToken<SpeechToTextServiceInterface>('SpeechToTextService'),
  SpeechToTextApiKeyService: new InjectionToken<SpeechToTextApiKeyServiceInterface>('SpeechToTextApiKeyService'),
};

export function provideSpeechToText(client: Environment['speechToTextProvider']): ClassProvider[] {
  if (client === 'azure') {
    return [
      {
        provide: Tokens.SpeechToTextService,
        useClass: SpeechToTextAzureService,
      },
      {
        provide: Tokens.SpeechToTextApiKeyService,
        useClass: SpeechToTextAzureApiKeyService,
      },
    ];
  } else {
    throw new Error('Invalid speech-to-text provider');
  }
}
